import { render, staticRenderFns } from "./DraftControl.vue?vue&type=template&id=5f56c037&"
import script from "./DraftControl.vue?vue&type=script&lang=js&"
export * from "./DraftControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports